import { getApiV2Client, getSegmentsGetHlsPlaylistUrl } from '@mi-front/api-v2';

/**
 * Builds the signed VOD HLS playlist URL for a bounded station recording range.
 * Adds 1 ms to `from` so the API does not return the previous segment.
 */
export function buildStationRangeHlsUrl(stationId: string, from: number, to: number): string {
  const { url } = getSegmentsGetHlsPlaylistUrl(stationId);

  return getApiV2Client().generateUrl(url, {
    secure: true,
    params: {
      from: String(from + 1),
      to: String(to),
    },
  });
}
